import React, { useRef, useState } from 'react';
import { Icon } from '../../../assets/icons';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Import default styles

// Phone mode extras (optional, existing forms are unaffected):
//   dialCode        country code the picker starts on, digits only ("216")
//   onCountryChange called with (dialCode, isoCode) when the USER picks another country; not called for the start-up value
export default function Input({ className, error, phone, icon, label, required, search, bgColor = '#F4F6FA', border = 'none', dialCode, onCountryChange, ...props }) {

    const [passwordVisible, setPasswordVisible] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState(dialCode ? String(dialCode) : '');
    const currentDial = useRef(dialCode ? String(dialCode) : null);
    const [countryCode, setCountryCode] = useState(() => {
        const userLanguage = navigator.language || navigator.userLanguage;
        // Extract country code from the user's language (assuming language code follows the pattern 'en-US')
        const countryCode = userLanguage.split('-')[1];
        return countryCode.toLowerCase();
    });

    const formatPhoneNumber = (value, country) => {
        const countryCode = country ? `+${country.callingCode}` : ''; // Get the country calling code
        return `${countryCode}-${value}`; // Concatenate country code and phone number
    };

    const handlePhoneChange = (value, country) => {
        // The picker reports the selected country on every change; tell the page only when its code really changed.
        const dial = country && typeof country === 'object' ? String(country.dialCode || '') : '';
        if (dial && dial !== currentDial.current) {
            currentDial.current = dial;
            if (onCountryChange) onCountryChange(dial, country.countryCode);
        }
        // Ensure value is a string
        const normalizedValue = typeof value === 'string' ? value : '';
        setPhoneNumber(formatPhoneNumber(normalizedValue, country));

        // Ensure country is a string
        const normalizedCountry = typeof country === 'string' ? country : '';
        setCountryCode(normalizedCountry);
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const searchCall = () => {
        if (search) {
            search();
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            searchCall();
        }
    };

    return (
        <div className={`relative ${className}`}>
            {label && (
                <label className="block text-sm text-[#4C4C66] pb-1 pl-2">{label}{required && ' *'}</label>
            )}
            <div className="flex items-center rounded-xl" style={{ backgroundColor: bgColor, border }}>
                {phone && (
                    <div className='w-[90px]'>
                        <PhoneInput
                            country={countryCode}
                            value={phoneNumber}
                            onChange={handlePhoneChange}
                            onMount={(value, country) => { if (!currentDial.current && country && country.dialCode) currentDial.current = String(country.dialCode); }}
                            inputProps={{
                                placeholder: '',
                                className: 'p-2 ml-10 max-w-[50px] bg-transparent outline-none ',
                            }}
                        />
                    </div>
                )}
                <input
                    {...props}
                    type={phone ? 'text' : (props.type === 'password' && !passwordVisible ? 'password' : 'text')} // Toggle input type
                    className={`bg-transparent text-[#4C4C66] outline-none flex-1 ${phone ? 'pl-0' : 'p-2'}`} // Adjust padding for icon
                    onKeyDown={handleKeyDown} // Add onKeyDown event handler
                />
                {(props.type === 'password') && (
                    <button type="button" onClick={togglePasswordVisibility} className="flex items-center pr-2">
                        <Icon icon={passwordVisible ? 'EyeSlash' : 'Eye'} className="h-6 w-6 text-gray-400" />
                    </button>
                )}
                {icon && props.type !== 'password' && (
                    <button onClick={searchCall} className="flex items-center pr-2">
                        <Icon icon={icon} className="h-6 w-6 text-gray-400" />
                    </button>
                )}
            </div>
            {error && (
                <span className="block mt-1 ml-2 text-xs text-[#FF0000]">
                    * {error}
                </span>
            )}
        </div>
    );
}
